





















































































































































import ConfirmDialog from '@/components/ConfirmDialog.vue'
import { checkPermissions } from '@/directives/permissionDirective'
import { ADMColumn } from '@/interfaces/adm-columns.interface'
import moment from 'moment'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({
    components: {
        ConfirmDialog
    }
})
export default class StatementList extends Vue {
    @Prop() loading!: boolean
    @Prop() selectRows!: boolean
    @Prop() customColums!: ADMColumn[]
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Prop() selectedRows!: any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Prop() columns!: any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Prop() dataRows!: any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Prop() pagination!: any
    @Prop() rowsPerPage!: number
    @Prop() sortBy!: string
    @Prop() sortByDesc!: boolean

    permissionPrefix = 'statement'
    confirmDialogTrigger = false
    confirmDialogData = null

    listSortDesc = false
    listSortBy = ''

    checkPermision (permission: string) {
        return !!checkPermissions(permission)
    }

    newLimitHandler (val: number) {
        this.$emit('newLimitHandler', val)
    }

    @Watch('pagination', { deep: true })
    paginationHandler () {
        this.$emit('paginationTable', this.pagination.currentPage)
    }

    mounted () {
        this.listSortBy = this.sortBy
        this.listSortDesc = this.sortByDesc
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    updateSortBy (item: any) {
        this.listSortBy = item || ''
        if (this.listSortBy === '') return
        this.$emit('loadData', { sortBy: this.listSortBy, sortByDesc: this.listSortDesc })
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    updateSort (item: any) {
        if (this.listSortDesc === !!item) return
        this.listSortDesc = !!item
        this.$emit('loadData', { sortBy: this.listSortBy, sortByDesc: this.listSortDesc })
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    matchVariableWithArray (variable: string, inputAttibute: string, outputAttibute: string, array: any[], output?: any[]): void|string|number {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const match: any = array.find(item => item[inputAttibute] === variable)
        if (output) output.push(match)
        if (!output) return match ? match[outputAttibute] : '-'
    }

    getDate (dateString: string) {
        return moment(dateString).format('MM/YYYY').toString()
    }

    getDateFormat (dateString: string) {
        const date = new Date(dateString)
        const day = date.getDate().toString().padStart(2, '0')
        const month = (date.getMonth() + 1).toString().padStart(2, '0')
        const year = date.getFullYear().toString().padStart(4, '0')
        const hours = date.getHours().toString().padStart(2, '0')
        const minutes = date.getMinutes().toString().padStart(2, '0')
        return `${day}/${month}/${year} - ${hours}:${minutes}`
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    editField (item: any) {
        this.$emit('editField', item)
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    notificationField (item: any) {
        this.$emit('notificationField', item)
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    downloadFile (item: any) {
        this.$store.dispatch('downloadStatementFile', item.statementId)
            .then(resp => {
                if (resp?.status === 200) {
                    this.$store.commit('reportSuccess', 'Done Successfully!')
                    const blob = new Blob([resp.data], { type: 'application/pdf' })
                    const url = window.URL.createObjectURL(blob)
                    window.open(url)
                }
            })
    }

    confirmedDialog (callback: {[key: string]: string|number|boolean}) {
        this.$store.dispatch('deleteStatements', callback.statementId)
            .then(resp => {
                if (resp?.status === 200) {
                    this.$store.commit('reportSuccess', 'Done Successfully!')
                    this.$emit('loadData')
                }
            })
    }
}
